export const SsoConst = {
    login: '/sso/login/',
    register: '/sso/register/',
    logout: '/sso/logout/',
};
